import { render, staticRenderFns } from "./HitosFacturacionComponent.vue?vue&type=template&id=8bfabbf4"
import script from "./HitosFacturacionComponent.vue?vue&type=script&lang=js"
export * from "./HitosFacturacionComponent.vue?vue&type=script&lang=js"
import style0 from "./HitosFacturacionComponent.vue?vue&type=style&index=0&id=8bfabbf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports